// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"eventCreate__gradient-bg5__FFuz8","section":"eventCreate__section__cUJmc","videoLink":"eventCreate__videoLink__HPDrG"};